import {useMutation} from "@tanstack/react-query";
import {message} from "antd";
import {AxiosError} from "axios";
import {AnalyticsEvent} from "../utils/analytics";
import {useClient} from "../utils/hooks";
import {normalizeV2CustomerAuthResponse} from "../redux/auth/auth-normalizer";

const useCustomerLogin = () => {
  const clientV2 = useClient("AUTH");

  return useMutation({
    mutationFn: async (payload: {emailAddress: string}) => {
      // POST /customers/auth/login (body: {email})
      const res = await clientV2(`customers/auth/login`, {
        method: "POST",
        data: {email: payload.emailAddress.toLowerCase()},
      });
      return {data: normalizeV2CustomerAuthResponse(res.data ?? res)};
    },
    onError: (error: AxiosError<{message: string}>) => {
      message.error(error.message);
      AnalyticsEvent("Customer Login", "Customer Login Fail");
    },
    onSuccess: () => {
      AnalyticsEvent("Customer Login", "Customer Login Success");
    },
  });
};
const useCustomerVerifyLink = () => {
  const clientV2 = useClient("AUTH");
  return useMutation({
    mutationFn: async (payload: {link?: string}) => {
      // POST customers/auth/confirm (body: {token})
      const res = await clientV2(`customers/auth/confirm`, {
        method: "POST",
        data: {token: payload.link},
      });
      return {data: normalizeV2CustomerAuthResponse(res.data ?? res)};
    },
    onError: (error: AxiosError<{message: string}>) => {
      message.error(error.message);
      AnalyticsEvent("Customer Link verification", "Customer Link verification Fail");
    },
    onSuccess: () => {
      AnalyticsEvent("Customer Link verification", "Customer Link verification Success");
    },
  });
};

export {useCustomerLogin, useCustomerVerifyLink};
